// extracted by mini-css-extract-plugin
export default {"LogoWrapper":"Header_LogoWrapper__LP7Aq","Accessibility":"Header_Accessibility__KyJI2"};